import React from 'react';
import '../stylesheets/candidate.scss';
 


class Candidate extends React.Component {
  constructor(props) {
    super(props)
    this.animationHover = React.createRef();
  };
  handleMouseEnter = () => {
    if (this.animationHover.current) {
      const description = this.animationHover.current;
      description.className = 'candidate-description-visible';
    };
  };
  handleMouseLeave = () => {
    if (this.animationHover.current) {
      const description = this.animationHover.current;
      description.className = 'candidate-description-hidden';
    };
  };
  render() {
    return (
      <li
        className='candidate-container'
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        >
        <div className='candidate'>
          <img 
            className='candidate-image' 
            src={ this.props.src} 
            alt={ this.props.alt } 
          />
          <div className='candidate-name'>
            { this.props.name }
          </div>
        </div>
        <div className='candidate-talent'>
          { this.props.talent }
        </div>
        <div
          className= 'candidate-description-hidden'
          ref={ this.animationHover }
          >
          <div className='candidate-ofert'>
            {`${ this.props.time } (${ this.props.availability })`}
          </div>
          <div className='candidate-location'>
            <i className='fa-solid fa-location-dot' />
            { this.props.location }
          </div>
        </div>
      </li>
    )
  }
}

export default Candidate;